module.exports = __webpack_public_path__ + "02@2x.png?27989259a9d28c92e0a65877707f3b3c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/02@2x.png
// module id = 80
// module chunks = 0